import { Component, OnInit } from '@angular/core';

/**
 * トップ画面
 * @export
 * @class Sgkz001dComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-sgkz001d',
  templateUrl: './sgkz001d.component.html',
  styleUrls: ['./sgkz001d.component.scss']
})
export class Sgkz001dComponent implements OnInit {

  /**
   * コンストラクタ
   * @memberof Sgkz001dComponent
   */
  constructor() { }

  /**
   * 初期処理
   * @memberof Sgkz001dComponent
   */
  ngOnInit(): void {
  }

}
